var _extendStatics = function extendStatics(a, c) {
  return _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (a, c) {
    a.__proto__ = c;
  } || function (a, c) {
    for (var b in c) {
      c.hasOwnProperty(b) && (a[b] = c[b]);
    }
  }, _extendStatics(a, c);
};

function __extends(a, c) {
  function b() {
    this.constructor = a;
  }

  _extendStatics(a, c), a.prototype = null === c ? Object.create(c) : (b.prototype = c.prototype, new b());
}

function __values(a) {
  var b = "function" == typeof Symbol && a[Symbol.iterator],
      c = 0;
  return b ? b.call(a) : {
    next: function next() {
      return a && c >= a.length && (a = void 0), {
        value: a && a[c++],
        done: !a
      };
    }
  };
}

var AnchorsExtension = [{
  name: "begin",
  func: function func() {
    return this.add("^"), this;
  }
}, {
  name: "end",
  func: function func() {
    return this.add("$"), this;
  }
}, {
  name: ["wordBoundary", "boundary"],
  func: function func() {
    return this.add({
      expr: "\\b",
      negate: function negate() {
        this.setExpr("\\B");
      }
    }), this;
  }
}],
    CharactersExtension = [{
  name: "set",
  func: function func(a) {
    var b;
    return b = "string" == typeof a ? a.replace(/\\|]|-/g, "\\$&") : a, this.add({
      expr: b,
      closure: {
        close: "]",
        open: "["
      },
      negate: function negate() {
        this.setClosure({
          close: "]",
          open: "[^"
        });
      }
    }), this;
  }
}, {
  name: "range",
  func: function func(a, b) {
    for (var c = [], d = 2; d < arguments.length; d++) {
      c[d - 2] = arguments[d];
    }

    var e = a + "-" + b,
        f = c ? c.length : 0;
    if (0 < f && 0 == f % 2) for (var g = 0; g < f; g += 2) {
      e += c[g] + "-" + c[g + 1];
    } else 0 != f % 2 && console.warn("Invalid range - omitted!");
    return this.add({
      expr: e,
      closure: {
        close: "]",
        open: "["
      },
      negate: function negate() {
        this.setClosure({
          close: "]",
          open: "[^"
        });
      }
    }), this;
  }
}, {
  name: ["any", "anyButBreak"],
  func: function func() {
    return this.add("."), this;
  }
}, {
  name: ["char", "wordChar"],
  func: function func() {
    return this.add({
      expr: "\\w",
      negate: function negate() {
        this.setExpr("\\W");
      }
    }), this;
  }
}, {
  name: "digit",
  func: function func() {
    return this.add({
      expr: "\\d",
      negate: function negate() {
        this.setExpr("\\D");
      }
    }), this;
  }
}, {
  name: ["whitespace", "anyWhitespace"],
  func: function func() {
    return this.add({
      expr: "\\s",
      negate: function negate() {
        this.setExpr("\\S");
      }
    }), this;
  }
}],
    EscapedCharactersExtension = [{
  name: "octal",
  func: function func(a) {
    return 3 === a.length && +a <= 377 ? this.add("\\" + a) : console.warn("Too big octal number - omitted!"), this;
  }
}, {
  name: "hex",
  func: function func(a) {
    return 2 === a.length ? this.add("\\x" + a) : console.warn("Not enough characters supplied - omitted!"), this;
  }
}, {
  name: "unicode",
  func: function func(a) {
    var b = this.containsFlag("u");
    return 4 >= a.length && !b ? this.add("\\u" + a) : b ? this.add("\\u{" + a + "}") : console.warn("Too many characters supplied without `u` flag applied - omitted!"), this;
  }
}, {
  name: "control",
  func: function func(a) {
    return 1 === a.length ? this.add("\\c" + a) : console.warn("Character was not supplied correctly - omitted!"), this;
  }
}, {
  name: "tab",
  func: function func() {
    return this.add("\\t"), this;
  }
}, {
  name: ["enter", "lineFeed"],
  func: function func() {
    return this.add("\\n"), this;
  }
}, {
  name: ["vTab", "verticalTab"],
  func: function func() {
    return this.add("\\v"), this;
  }
}, {
  name: "formFeed",
  func: function func() {
    return this.add("\\f"), this;
  }
}, {
  name: "carriageReturn",
  func: function func() {
    return this.add("\\r"), this;
  }
}, {
  name: "codeZero",
  func: function func() {
    return this.add("\\0"), this;
  }
}],
    FlagsExtension = [{
  name: ["ignoreCase", "i"],
  func: function func() {
    return this.addFlag("i"), this;
  }
}, {
  name: ["globalize", "g", "global"],
  func: function func() {
    return this.addFlag("g"), this;
  }
}, {
  name: ["extendedUnicodes", "u"],
  func: function func() {
    return this.addFlag("u"), this;
  }
}, {
  name: ["multiline", "m"],
  func: function func() {
    return this.addFlag("m"), this;
  }
}, {
  name: ["singleByIndex", "y", "sticky"],
  func: function func() {
    return this.addFlag("y"), this;
  }
}],
    GroupExtension = [{
  name: ["capture", "group"],
  func: function func(a) {
    return this.add({
      expr: a,
      closure: {
        close: ")",
        open: "("
      },
      negate: function negate() {
        this.setClosure({
          close: ")",
          open: "(?:"
        });
      }
    }), this;
  }
}, {
  name: ["ref", "reference"],
  func: function func(a) {
    return this.add("\\k<" + a + ">"), this;
  }
}, {
  name: "as",
  func: function func(a) {
    var b = this.lastOperation ? this.lastOperation.closure : {
      open: "",
      close: ""
    },
        c = b.open,
        d = b.close;
    return this.lastOperation && "(" === c && ")" === d ? this.lastOperation.setClosure({
      open: "(?<" + a + ">"
    }) : this.lastOperation ? this.lastOperation.setClosure({
      open: "(?<" + a + ">" + c,
      close: d + ")"
    }) : console.warn("No operation to be referenced - omitted!"), this;
  }
}],
    LookAroundExtension = [{
  name: ["follow", "after"],
  func: function func(a) {
    return this.add({
      expr: a,
      closure: {
        close: ")",
        open: "(?="
      },
      negate: function negate() {
        this.setClosure({
          open: "(?!"
        });
      }
    }), this;
  }
}, {
  name: ["precede", "before"],
  func: function func(a) {
    return this.add({
      expr: a,
      closure: {
        close: ")",
        open: "(?<="
      },
      negate: function negate() {
        this.setClosure({
          open: "(?<!"
        });
      }
    }), this;
  }
}],
    QuantifiersExtension = [{
  name: ["or", "alternative"],
  func: function func(a) {
    return this.add("|"), this.add({
      expr: a
    }), this;
  }
}, {
  name: ["lazy", "minimum"],
  func: function func() {
    return this.add("?"), this;
  }
}, {
  name: ["optional", "unnecessary", "additional"],
  func: function func() {
    return this.add("?"), this;
  }
}, {
  name: ["withLimits", "quantify"],
  func: function func(a, b) {
    return b ? this.add("{" + a + "," + b + "}") : this.add("{" + a + "}"), this;
  }
}, {
  name: ["moreOrNot", "star"],
  func: function func() {
    return this.add("*"), this;
  }
}, {
  name: ["more", "plus"],
  func: function func() {
    return this.add("+"), this;
  }
}],
    getClosingBracket = function getClosingBracket(a, b, c) {
  var d,
      e = c ? c : a[b],
      f = a.length,
      g = b,
      h = 1;
  d = "(" === e ? ")" : "<" === e ? ">" : ")";

  for (var j = b + 1; j < f && (g += 1, a[j] === e ? h += 1 : a[j] === d && (h -= 1), 0 !== h); j += 1) {
    ;
  }

  return g;
},
    getTextBetweenBrackets = function getTextBetweenBrackets(a, b, c) {
  var d = getClosingBracket(a, b, c);
  return a.substring(b + 1, d);
},
    getNumberOfBracketsInside = function getNumberOfBracketsInside(a, b, c) {
  for (var d, e = c ? c : a[b], f = getTextBetweenBrackets(a, b, e), g = 0, h = 0; h < f.length && (d = f.indexOf(e), -1 < d); h += 1) {
    "?" !== f[d + 1] && ":" !== f[d + 2] && (g += 1);
  }

  return g;
},
    Polyfiller = function () {
  function a() {
    var a = this;
    this.lookBehinds = {
      positive: [],
      negative: []
    }, this.namedGroups = {}, this.groupIndex = 0, this.preprocessedRegEx = "", this.regEx = "", this.mapPolyfills = function (b) {
      a.groupIndex = 0, a.preprocessedRegEx = a.regEx = b;

      for (var c = -1, d = 0; d < a.regEx.length && (c = a.regEx.indexOf("(", c + 1), -1 < c); d += 1) {
        var e = a.regEx[c + 1],
            f = a.regEx[c + 2],
            g = a.regEx[c + 3];
        "?" === e ? ":" !== f && "<" === f && ("=" === g ? (a.groupIndex += 1, a.mapPositiveLookBehind(getTextBetweenBrackets(a.regEx, c + 3, "(")), a.groupIndex += 1) : "!" === g ? (a.groupIndex += 1, a.mapNegativeLookBehind(getTextBetweenBrackets(a.regEx, c + 3, "(")), a.groupIndex += 1) : (a.groupIndex += 1, a.mapNamedGroup())) : a.groupIndex += 1;
      }

      return a.mapNamedGroupsBackreferences(), a.preprocessedRegEx;
    }, this.applyNegativeLookBehinds = function (b) {
      var c,
          d,
          e = b;

      try {
        for (var f = __values(a.lookBehinds.negative), g = f.next(); !g.done; g = f.next()) {
          var h = g.value,
              i = b[h.behind];
          if (i) return null;
          e.splice(h.value, 1), e.splice(h.behind, 1);
        }
      } catch (a) {
        c = {
          error: a
        };
      } finally {
        try {
          g && !g.done && (d = f.return) && d.call(f);
        } finally {
          if (c) throw c.error;
        }
      }

      return e;
    }, this.applyPositiveLookBehinds = function (b) {
      var c,
          d,
          e = b,
          f = -1;

      try {
        for (var g = __values(a.lookBehinds.positive), h = g.next(); !h.done; h = g.next()) {
          var i = h.value,
              j = b[i.behind];

          if (j) {
            var k = e[0].split(""),
                l = j.length;
            f = b[0].indexOf(j, f + 1), 0 === f && (e.index = l), k.splice(f, l), e[0] = k.join(""), e.splice(i.value, 1), e.splice(i.behind, 1);
          } else return null;
        }
      } catch (a) {
        c = {
          error: a
        };
      } finally {
        try {
          h && !h.done && (d = g.return) && d.call(g);
        } finally {
          if (c) throw c.error;
        }
      }

      return e;
    }, this.applyNamedGroups = function (b) {
      var c = b;

      for (var d in c.groups = {}, a.namedGroups) {
        var e = a.namedGroups[d];
        c.groups[d] = b[e];
      }

      return c;
    }, this.mapPositiveLookBehind = function (b) {
      a.lookBehinds.positive.push({
        behind: a.groupIndex,
        value: a.groupIndex + getNumberOfBracketsInside(a.preprocessedRegEx, a.preprocessedRegEx.indexOf("(?<=" + b + ")") + 6 + b.length) + 1
      }), a.preprocessedRegEx = a.preprocessedRegEx.replace("(?<=" + b + ")", "(" + b + ")?("), a.preprocessedRegEx += ")";
    }, this.mapNegativeLookBehind = function (b) {
      a.lookBehinds.negative.push({
        behind: a.groupIndex,
        value: a.groupIndex + getNumberOfBracketsInside(a.preprocessedRegEx, a.preprocessedRegEx.indexOf("(?<=" + b + ")") + 6 + b.length) + 1
      }), a.preprocessedRegEx = a.preprocessedRegEx.replace("(?<!" + b + ")", "(" + b + ")?("), a.preprocessedRegEx += ")";
    };
  }

  return a.prototype.applyPolyfills = function (a) {
    var b = a;
    return b && (b = this.applyNamedGroups(b)), b && (b = this.applyPositiveLookBehinds(b)), b && (b = this.applyNegativeLookBehinds(b)), b;
  }, a.prototype.reset = function () {
    this.groupIndex = 0, this.lookBehinds = {
      positive: [],
      negative: []
    }, this.namedGroups = {}, this.regEx = "", this.preprocessedRegEx = "";
  }, a.prototype.mapNamedGroup = function () {
    var a = this;
    this.preprocessedRegEx = this.preprocessedRegEx.replace(/\?<(\w+)>/, function (b, c) {
      return a.namedGroups[c] = a.groupIndex, "";
    });
  }, a.prototype.mapNamedGroupsBackreferences = function () {
    for (var a, b = -1, c = 0; c < this.regEx.length && (b = this.regEx.indexOf("\\k<", b + 1), -1 < b); c += 1) {
      a = getTextBetweenBrackets(this.regEx, b + 2), this.preprocessedRegEx = this.preprocessedRegEx.replace("\\k<" + a + ">", "\\" + this.namedGroups[a]);
    }
  }, a;
}(),
    Parser = function () {
  function a(a, b) {
    var c = this;
    this.flags = [], this.expr = "", this.lastIndex = 0, this.polyfiller = new Polyfiller(), this.regEx = void 0, this.update = function (a, b) {
      c.expr = a, c.flags = b.split(""), c.polyfiller.reset(), c.regEx = void 0;
    }, this.match = function (a) {
      if (c.regEx || c.preprocess(), c.regEx) {
        var b = c.regEx.exec(a);
        if (b) return -1 < c.flags.indexOf("g") && (c.lastIndex = c.regEx.lastIndex), c.polyfiller.applyPolyfills(b);
      }

      return null;
    }, this.test = function (a) {
      c.lastIndex = 0;
      var b = c.match(a);
      return !!(b && 0 < b.length);
    }, this.matchAll = function (a) {
      var b = [],
          d = !1;
      c.lastIndex = 0, -1 === c.flags.indexOf("g") && (d = !0, c.update(c.expr, c.flags.join("") + "g"));

      for (var e, f = 0; f < 1 / 0 && (e = c.match(a), e); f += 1) {
        b.push(e);
      }

      return d && (c.flags.pop(), c.update(c.expr, c.flags.join(""))), 0 < b.length ? b : null;
    }, this.search = function (a) {
      c.lastIndex = 0;
      var b = c.match(a);
      return b && b.index ? b.index : -1;
    }, this.split = function (a, b) {
      var d = c.matchAll(a),
          e = [],
          f = 0;
      if (d) for (var g = b && b <= d.length ? b : d.length, h = 0; h < g; h += 1) {
        var j = d[h],
            k = a.substring(f, j.index);
        "" !== k && e.push(k), f = j.index + j[0].length;
      }
      var l = a.substring(f, a.length);
      return "" !== l && e.push(l), e;
    }, this.update(a ? a : "", b ? b : "");
  }

  return a.prototype.preprocess = function () {
    var a = this.polyfiller.mapPolyfills(this.expr);
    this.regEx = new RegExp(a, this.flags.join("")), this.regEx.lastIndex = this.lastIndex;
  }, a;
}(),
    Operation = function () {
  return function (a) {
    var b = this;
    if (this.expr = "", this.closure = {
      open: "",
      close: ""
    }, this.setExpr = function (a) {
      b.expr = a;
    }, this.setClosure = function (a) {
      a.open && (b.closure.open = a.open), a.close && (b.closure.close = a.close);
    }, this.setNegate = function (a) {
      b.negate = a;
    }, this.stringify = function (a) {
      var c = b.closure,
          d = c.open,
          e = c.close,
          f = b.expr;
      return "string" == typeof f ? d + f + e : f instanceof ReXer ? d + f.getExpr() + e : d + a.stringifyExpression(f) + e;
    }, "string" == typeof a || a instanceof ReXer) this.expr = a;else {
      var c = a.expr,
          d = a.closure,
          e = a.negate;
      this.expr = c, d && this.setClosure(d), e && (this.negate = e);
    }
  };
}(),
    ReXer = function () {
  function a() {
    var a = this;
    this.lastOperation = null, this.operationChannels = [[]], this.channelIndex = 0, this.snippets = {}, this.insertSnippet = function (b) {
      return a.add(a.snippets[b]), a;
    }, this.stringifyChannel = function (b) {
      var c = a.operationChannels[b],
          d = "";
      return c.forEach(function (b) {
        d += b.stringify(a);
      }), d;
    }, this.setChannel = function (b) {
      return a.channelIndex = b, b;
    };
  }

  return a.prototype.add = function (a) {
    var b = new Operation(a);
    return this.operationChannels[this.channelIndex].push(b), this.lastOperation = b, this;
  }, a.prototype.repeat = function () {
    return this.lastOperation ? this.operationChannels[this.channelIndex].push(this.lastOperation) : console.warn("No operation to be repeated - omitted!"), this;
  }, a.prototype.getExpr = function () {
    return this.stringifyChannel(0);
  }, a.prototype.useMethod = function (a) {
    var b,
        c,
        d = a.name,
        e = a.func;
    if ("string" == typeof d) this[d] = e;else try {
      for (var f, g = __values(d), h = g.next(); !h.done; h = g.next()) {
        f = h.value, this[f] = e;
      }
    } catch (a) {
      b = {
        error: a
      };
    } finally {
      try {
        h && !h.done && (c = g.return) && c.call(g);
      } finally {
        if (b) throw b.error;
      }
    }
  }, a.prototype.useExtension = function (a) {
    var b, c;

    try {
      for (var d, e = __values(a), f = e.next(); !f.done; f = e.next()) {
        d = f.value, this.useMethod(d);
      }
    } catch (a) {
      b = {
        error: a
      };
    } finally {
      try {
        f && !f.done && (c = e.return) && c.call(e);
      } finally {
        if (b) throw b.error;
      }
    }
  }, a.prototype.createSnippet = function (a, b) {
    return this.snippets[a] = b, this;
  }, a.prototype.stringifyExpression = function (a) {
    var b = this.setChannel(this.createChannel());
    a(this);
    var c = this.stringifyChannel(b);
    return this.setChannel(0), c;
  }, a.prototype.createChannel = function () {
    var a = this.operationChannels.push([]) - 1;
    return a;
  }, a;
}(),
    Matcher = function (a) {
  function b() {
    var b = a.call(this) || this;
    return b.parser = new Parser(), b.test = function (a) {
      return b.preprocess(), b.parser.test(a);
    }, b.match = function (a) {
      return b.preprocess(), b.parser.match(a);
    }, b.matchAll = function (a) {
      return b.preprocess(), b.parser.matchAll(a);
    }, b.search = function (a) {
      return b.preprocess(), b.parser.search(a);
    }, b.split = function (a, c) {
      return b.preprocess(), b.parser.split(a, c);
    }, b.setLastIndex = function (a) {
      return b.parser.lastIndex = a, b;
    }, b.find = function (a) {
      var c = /\+|\*|\?|\^|\$|\.|\[|\]|\{|\}|\(|\)|\||\/|\\/g;
      return b.add(a.replace(c, "\\$&")), b;
    }, b.negate = function () {
      return b.lastOperation && b.lastOperation.negate ? b.lastOperation.negate() : console.warn("Operation doesn't implement negate method!"), b;
    }, b.addFlag = function (a) {
      var c = b.parser,
          d = c.flags,
          e = c.expr,
          f = c.update;
      return f(e, d.join("") + a), b;
    }, b.removeFlag = function (a) {
      var c = b.parser,
          d = c.expr,
          e = c.flags,
          f = c.update,
          g = e.indexOf(a);
      return -1 < g ? (e.splice(g, 1), f(d, e.join(""))) : console.warn("No such flag exist to remove - omitted!"), b;
    }, b.containsFlag = function (a) {
      return -1 < b.parser.flags.indexOf(a);
    }, b.preprocess = function () {
      var a = b.parser,
          c = a.flags,
          d = a.update;
      d(b.getExpr(), c.join(""));
    }, b.useExtension(AnchorsExtension), b.useExtension(CharactersExtension), b.useExtension(EscapedCharactersExtension), b.useExtension(FlagsExtension), b.useExtension(GroupExtension), b.useExtension(LookAroundExtension), b.useExtension(QuantifiersExtension), b;
  }

  return __extends(b, a), b;
}(ReXer),
    ReplaceExtension = [{
  name: "matched",
  func: function func() {
    return this.add("$&"), this;
  }
}, {
  name: "captured",
  func: function func(a) {
    return this.add("$<" + a + ">"), this;
  }
}, {
  name: "beforeMatched",
  func: function func() {
    return this.add("$`"), this;
  }
}, {
  name: "afterMatched",
  func: function func() {
    return this.add("$'"), this;
  }
}, {
  name: "dollar",
  func: function func() {
    return this.add("$$"), this;
  }
}],
    Replacer = function (a) {
  function b() {
    var b = a.call(this) || this;
    return b.replace = function (a, c) {
      var d = a.match(c),
          e = a.split(c, 1);

      if (d) {
        var f = b.replacementExpr(d),
            g = 0 === d.index ? 0 : 1;
        e.splice(g, 0, d[0].replace(d[0], f));
      }

      return e.join("");
    }, b.replaceAll = function (a, c) {
      var d,
          e,
          f = a.matchAll(c),
          g = a.split(c),
          h = 1;
      if (f) try {
        for (var i = __values(f), j = i.next(); !j.done; j = i.next()) {
          var k = j.value,
              l = b.replacementExpr(k);
          h = 0 === k.index ? 0 : h, g.splice(h, 0, k[0].replace(k[0], l)), h += 2;
        }
      } catch (a) {
        d = {
          error: a
        };
      } finally {
        try {
          j && !j.done && (e = i.return) && e.call(i);
        } finally {
          if (d) throw d.error;
        }
      }
      return g.join("");
    }, b.replacementExpr = function (a) {
      var c = b.getExpr(),
          d = c,
          e = -1;
      if (a.groups) for (var f, g = 0; g < c.length && (e = c.indexOf("$<", e + 1), -1 < e); g += 1) {
        f = getTextBetweenBrackets(c, e + 1), d = d.replace("$<" + f + ">", a.groups[f]);
      }
      return d;
    }, b.useExtension(ReplaceExtension), b;
  }

  return __extends(b, a), b;
}(ReXer);

export { Matcher, Replacer, Operation, Parser, ReXer };